import React from "react";

const Stars = ({ value = 4.7 }) => {
  const fullStars = Math.floor(value);
  const hasHalf = value % 1 >= 0.3;
  return (
    <span className="text-warning">
      {[...Array(fullStars)].map((_, i) => (
        <i key={`f-${i}`} className="bi bi-star-fill me-0.5" />
      ))}
      {hasHalf && <i className="bi bi-star-half me-0.5" />}
      {[...Array(Math.max(0, 5 - fullStars - (hasHalf ? 1 : 0)))].map((_, i) => (
        <i key={`e-${i}`} className="bi bi-star text-muted opacity-50 me-0.5" />
      ))}
    </span>
  );
};

export default function Header({ user, selectedShop, progression, metrics }) {
  const displayName = user?.fullname || user?.email || "Agent User";
  const initials = user?.initials || displayName.slice(0, 2).toUpperCase();
  const commission = progression?.activeCommissionRate ?? 5.0;
  const tierLabel = progression?.currentTierLabel || "TIER 1 (IN PROGRESS)";
  const rating = metrics?.averageRating ?? 4.7;

  return (
    <div className="marketing_level_header_grid mb-4 mt-3">
      <div className="marketing_level_min0">
        <div className="d-flex align-items-center gap-2 mb-2 small flex-wrap">
          <span className="badge marketing_level_bg_blue rounded-pill px-3 py-2">
            Career Milestone System
          </span>
          <span className="marketing_level_text_muted">
            <i className="bi bi-dot" />
            Scale Up to 15% Maximum Commission
          </span>
          {selectedShop?.shopname && (
            <span className="badge bg-light text-primary border rounded-pill px-2.5 py-1.5 fw-semibold">
              <i className="bi bi-shop me-1" />
              {selectedShop.shopname}
            </span>
          )}
        </div>
        <h1 className="fw-bold marketing_level_title mb-1">
          Agent Levels &amp; Rewards Progression
        </h1>
        <p className="marketing_level_text_muted mb-0">
          Track qualifying client volume, real-time connectivity ratings, territorial expansion nodes, and dynamic tier commissions.
        </p>
      </div>

      <div className="marketing_level_min0">
        <div className="card shadow-sm border-0 rounded-4">
          <div className="card-body d-flex align-items-center gap-3 py-2">
            <div className="position-relative">
              {user?.imageUrl ? (
                <img
                  src={user.imageUrl}
                  alt={displayName}
                  className="rounded-circle object-fit-cover shadow-sm"
                  style={{ width: 46, height: 46 }}
                  onError={(e) => {
                    e.target.style.display = "none";
                    if (e.target.nextSibling) e.target.nextSibling.style.display = "flex";
                  }}
                />
              ) : null}
              <div
                className="rounded-circle bg-primary text-white fw-bold d-flex align-items-center justify-content-center shadow-sm"
                style={{
                  width: 46,
                  height: 46,
                  display: user?.imageUrl ? "none" : "flex",
                }}
              >
                {initials}
              </div>
            </div>

            <div className="flex-grow-1 min-w-0">
              <div className="fw-bold text-truncate" title={displayName}>
                {displayName}
              </div>
              <div className="small marketing_level_text_gold fw-semibold">
                {Number(commission).toFixed(1)}% Commission
              </div>
            </div>

            <div className="text-end flex-shrink-0">
              <span className="badge marketing_level_bg_gray border text-truncate" style={{ maxWidth: 170 }}>
                {tierLabel}
              </span>
              <div className="small marketing_level_text_gold fw-semibold mt-1">
                <i className="bi bi-star-fill me-1" />
                {rating} Rating
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export { Stars };

